import { render, staticRenderFns } from "./release-notes.vue?vue&type=template&id=2ffa1c3e&scoped=true&"
import script from "./release-notes.vue?vue&type=script&lang=js&"
export * from "./release-notes.vue?vue&type=script&lang=js&"
import style0 from "./release-notes.vue?vue&type=style&index=0&id=2ffa1c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa1c3e",
  null
  
)

export default component.exports